export const API = "https://noteable-be.vercel.app"

// export const API =  "http://localhost:5000"

